export const SKAN_DAYS_TO_ACCEPT_LATE_DATA = 30;
export const LOWEST_FINE_CONVERSION_VALUE = 0;
export const HIGHEST_FINE_CONVERSION_VALUE = 63;

export const COARSE_CONVERSION_VALUE_LOW = 'low';
export const COARSE_CONVERSION_VALUE_MEDIUM = 'medium';
export const COARSE_CONVERSION_VALUE_HIGH = 'high';
export const COARSE_CONVERSION_VALUES = [
  COARSE_CONVERSION_VALUE_LOW,
  COARSE_CONVERSION_VALUE_MEDIUM,
  COARSE_CONVERSION_VALUE_HIGH,
];

export const POSTBACK_INDEX_0_KEY = 'postback-sequence-index-0';
export const POSTBACK_INDEX_1_KEY = 'postback-sequence-index-1';
export const POSTBACK_INDEX_2_KEY = 'postback-sequence-index-2';

export const POSTBACK_INDEX_0_VALUE = '0';
export const POSTBACK_INDEX_1_VALUE = '1';
export const POSTBACK_INDEX_2_VALUE = '2';

export const READONLY_FINE_CONVERSION_VALUE = '0';

export const ALL_ALIASES_OPTION_VALUE = '@@@all';

export const DEFAULT_ALIAS_OPTION = {
  value: ALL_ALIASES_OPTION_VALUE,
  label: 'All Aliases',
};

export const COMMERCE_EVENTS_NAMES = [
  'PURCHASE',
  'ADD_TO_CART',
  'ADD_TO_WISHLIST',
  'VIEW_CART',
  'INITIATE_PURCHASE',
  'ADD_PAYMENT_INFO',
  'SPEND_CREDITS',
  'RESERVE',
  'CLICK_AD',
  'VIEW_AD',
];
